<div class="slide slide--languages" [style.--slide-accent-color]="titleColor">
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>

		<div class="slide__kpi" *ngIf="!isEmpty && topSharePct">
			<typography variant="h/1" class="slide__kpi-value">
				{{ topSharePct }}
			</typography>
			<div class="slide__kpi-label-row">
				<span class="slide__kpi-dot"></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					{{ topShareLabel }}
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="!isEmpty">
		<div class="slide__chart-panel slide__chart-host">
			<div class="slide__donut-wrap" *ngIf="!chartSwitch.block">
				<canvas
					baseChart
					[data]="doughnutData"
					[options]="doughnutOptions"
					[type]="doughnutType"
				></canvas>
			</div>
			<app-report-chart-switch
				[state]="chartSwitch"
				[themeColor]="themeColor"
				[editorMode]="editorMode"
				(chartTypeChange)="chartTypeChange.emit($event)"
			></app-report-chart-switch>
		</div>

		<div class="slide__table-panel">
			<typography variant="p/base_semibold" class="slide__table-title">
				Language breakdown
			</typography>
			<div class="slide__table">
				<div class="slide__table-head">
					<span class="slide__th slide__th--lang">Language</span>
					<span class="slide__th slide__th--num">Share</span>
					<span class="slide__th slide__th--num">Mentions</span>
				</div>
				<div
					class="slide__table-row"
					*ngFor="let stat of languageStats; trackBy: trackByLanguage"
				>
					<span class="slide__td slide__td--lang">
						<span
							class="slide__lang-dot"
							[style.background]="stat.color"
						></span>
						<typography
							variant="p/sm_regular"
							class="slide__lang-name"
						>
							{{ stat.language }}
						</typography>
					</span>
					<span class="slide__td slide__td--num">
						{{ stat.sharePct }}
					</span>
					<span class="slide__td slide__td--num">
						{{ stat.mentions | number }}
					</span>
				</div>
			</div>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">languages</div>
	</div>
</div>
